import React from "react";

export default function LessonLoader() {
  return (
    <section className="flex animate-pulse flex-col">
      {/* header skeleton */}
      <div className="flex items-center justify-between rounded-t-2xl bg-slate-200 p-4 lg:p-6">
        <div className="h-8 w-1/3 rounded bg-slate-300" />
      </div>

      <div className="flex h-fit flex-col gap-4 overflow-hidden rounded-b-2xl border border-slate-200 bg-slate-50 p-6 shadow-none">
        {/* Title skeleton */}
        <div className="mb-4 h-6 w-1/2 rounded bg-slate-300" />

        {/* Options skeleton */}
        <div className="space-y-4">
          <div className="h-6 w-full rounded bg-slate-200" />
          <div className="h-6 w-full rounded bg-slate-200" />
          <div className="h-6 w-full rounded bg-slate-200" />
        </div>

        {/* Button skeletons */}
      </div>

      <div className="mt-6 flex justify-between gap-4">
        <div className="h-8 w-24 rounded bg-slate-300" />
        <div className="h-8 w-24 rounded bg-slate-300" />
      </div>
    </section>
  );
}
